export default __webpack_public_path__ + "static/media/adaptive_ocean_hood.57d8a255.jpg";